import { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useTheme } from "@mui/material";

interface Props {
  total_shift_count: null | any[];
}

const AttendancePieChart = (props: Props) => {
  const theme = useTheme();
  /* const dispatch = useDispatch();
  const { total_shift_count, loading } = useSelector(
    (state: storeStateType) => state.dashboard
  ); */

  const [datas, setDatas] = useState<{ name: string; value: string }[]>([]);

  useEffect(() => {
    if (props.total_shift_count) {
      let mappedObject = props.total_shift_count.map((item: any) => {
        return { name: item.shift, value: item.count };
      });
      setDatas(mappedObject);
    }
  }, [props.total_shift_count]);

  let data = datas.map((data: any) => {
    return { name: data.name, y: data.value };
  });
  const options = {
    credits: {
      enabled: false,
    },
    chart: {
      type: "pie",
      backgroundColor: theme?.palette?.background?.paper,
    },
    title: {
      text: "Shifts",
      style: {
        color: theme?.palette?.text?.secondary,
      },
    },
    colors: ["#66ffd9", "#66d9ff", "#66b3ff", "#006400"],
    series: [
      {
        data: data,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default AttendancePieChart;
